import { render, staticRenderFns } from "./Kupovina.vue?vue&type=template&id=7607c3f4&"
import script from "./Kupovina.vue?vue&type=script&lang=js&"
export * from "./Kupovina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports